import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { IconButton, Delete } from '@tds/core-interactive-icon';
import Overlay from './overlay';

const DeleteButton = ({ id, name, fetchData }) => {
  const [inDeleteMode, setInDeleteMode] = useState(false);

  return (
    <>
      <IconButton
        icon={Delete}
        onClick={() => {
          setInDeleteMode(true);
        }}
        a11yText="Reduce"
      />
      {inDeleteMode && (
        <Overlay
          setInDeleteMode={setInDeleteMode}
          id={id}
          name={name}
          fetchData={fetchData}
        />
      )}
    </>
  );
};

DeleteButton.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  fetchData: PropTypes.func.isRequired
};

export default DeleteButton;
